import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';  
import './rubros.css'


import MenuItem from '@material-ui/core/MenuItem';

import { Link } from 'react-router-dom'




class DialogRubro extends React.Component {
    constructor(props){
        super(props)

        this.state = {
            open:true,          
            openList: false,
            valid:true
        } 
    }

      handleContinuar = () => {
        let valid = this.validar()
        
        if (valid === true )
        {
          this.setState({ open: false })
        }
        else{
          this.setState({
            valid: false
          })
        }
      };

      validar = () => {
        if (this.props.selectedIndexRubro === 0) return false
        else return true
      }

    render() {

        
        return (
            <div>
                <Dialog
                 
                  fullWidth = {true}
                  maxWidth= "sm"
                  open={this.state.open}
                  onClose={this.handleClose}
                  aria-labelledby="form-dialog-title"
                >
                <DialogTitle id="form-dialog-title">Seleccionar Rubro</DialogTitle>
                
                <Divider />  
                  
                  <DialogContent >
                    
                    <TextField
                      id="rubros"
                      select
                      error={this.state.valid === false? true : false}
                      helperText={this.state.valid === false? 'Por favor seleccione un rubro' : 'Seleccionar'}
                      label="Rubro"          
                      value={this.props.selectedIndexRubro === 0 ? '' : this.props.selectedIndexRubro}
                      onChange={(e) => this.props.handleChangeRubro(e)}
                      style={{width:'100%'}}
                      margin="normal"
                    >
                      {this.props.rubros.map(item => (
                        <MenuItem key={item.idRubro} value={item.idRubro}>
                          {item.nombre}
                        </MenuItem>
                      ))}
                    </TextField>
                  
                  </DialogContent>
                    
                    <DialogActions id="ecommerce">
                        <Button onClick={this.props.handleCancelButton} className="btnSecundario">
                          Cancelar
                        </Button>
                        
                      
                      {this.props.selectedIndexRubro !== 0?

                      <Link to={{ pathname: '/Articulo/articuloNuevo', 
                                  idCatalogo: this.props.idCatalogo,
                                  payloadRubro: this.props.payloadRubro}} 
                                  style={{ textDecoration: 'none' }}   >             
                        <Button onClick={this.handleClose} className="btnPrincipal">
                          Continuar
                        </Button>
                      </Link> : 
                        <Button  onClick= {this.handleContinuar} className="btnPrincipal">
                          Continuar
                        </Button> }

                    </DialogActions>
                </Dialog>
          </div>
        )
    }
}



DialogRubro.defaultProps = {
    rubros: []
}

export default DialogRubro